/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AiLifecycleDashboardContent } from '../model';
// @ts-ignore
import type { Comment } from '../model';
// @ts-ignore
import type { Concept } from '../model';
// @ts-ignore
import type { Control } from '../model';
// @ts-ignore
import type { ErrorResponse } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { Logs } from '../model';
// @ts-ignore
import type { PageControl } from '../model';
// @ts-ignore
import type { PageControlList } from '../model';
// @ts-ignore
import type { PlatformFrameworkVersionOverview } from '../model';
// @ts-ignore
import type { Project } from '../model';
// @ts-ignore
import type { ProjectAggregator } from '../model';
// @ts-ignore
import type { ProjectAiSystemLifecycleDashboard } from '../model';
// @ts-ignore
import type { ProjectDashboard } from '../model';
// @ts-ignore
import type { ProjectFrameworksFreezeUpdate } from '../model';
// @ts-ignore
import type { Status } from '../model';
// @ts-ignore
import type { TestingLog } from '../model';
// @ts-ignore
import type { TestingLogCreate } from '../model';
// @ts-ignore
import type { TestingTest } from '../model';
// @ts-ignore
import type { TestingTestAndResultPage } from '../model';
// @ts-ignore
import type { TestingTestResultPage } from '../model';
// @ts-ignore
import type { TestingTestStatus } from '../model';
/**
 * ProjectsApi - axios parameter creator
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Testing Testing To Control
         * @param {string} projectId 
         * @param {string} controlId 
         * @param {string} testingTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut: async (projectId: string, controlId: string, testingTestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut', 'projectId', projectId)
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut', 'controlId', controlId)
            // verify required parameter 'testingTestId' is not null or undefined
            assertParamExists('addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut', 'testingTestId', testingTestId)
            const localVarPath = `/v1/projects/{project_id}/testing/tests/{testing_test_id}/controls/{control_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)))
                .replace('{control_id}', encodeURIComponent(String(controlId)))
                .replace('{testing_test_id}', encodeURIComponent(String(testingTestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a monitoring datasource.  Args:     testing_log (TestingLogCreate): Monitoring datasource data.     project (Project): Project.     db (Session): Database session.  Returns:     TestingLog: Monitoring datasource.  Raises:     HTTPException: AI System or testing metric not found.
         * @summary Create Testing Log
         * @param {string} projectId 
         * @param {TestingLogCreate} testingLogCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestingLogV1ProjectsProjectIdTestingLogsPost: async (projectId: string, testingLogCreate: TestingLogCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createTestingLogV1ProjectsProjectIdTestingLogsPost', 'projectId', projectId)
            // verify required parameter 'testingLogCreate' is not null or undefined
            assertParamExists('createTestingLogV1ProjectsProjectIdTestingLogsPost', 'testingLogCreate', testingLogCreate)
            const localVarPath = `/v1/projects/{project_id}/testing/logs`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testingLogCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Project
         * @param {string} projectId 
         * @param {string} [timeZone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProjectV1ProjectsProjectIdExportPost: async (projectId: string, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('exportProjectV1ProjectsProjectIdExportPost', 'projectId', projectId)
            const localVarPath = `/v1/projects/{project_id}/export`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeZone !== undefined) {
                localVarQueryParameter['time_zone'] = timeZone;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the project freezed flag with the given id.  Args:     project_id (UUID): The project\'s id.     project_freezed (UpdateProjectFreezed): The freezed value for the project.     db (Session): Database session.  Returns:     schemas.Project: The updated project.
         * @summary Freeze Project Frameworks Update
         * @param {string} projectId 
         * @param {ProjectFrameworksFreezeUpdate} projectFrameworksFreezeUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch: async (projectId: string, projectFrameworksFreezeUpdate: ProjectFrameworksFreezeUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch', 'projectId', projectId)
            // verify required parameter 'projectFrameworksFreezeUpdate' is not null or undefined
            assertParamExists('freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch', 'projectFrameworksFreezeUpdate', projectFrameworksFreezeUpdate)
            const localVarPath = `/v1/projects/{project_id}/freeze-frameworks-update`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectFrameworksFreezeUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     ProjectAiSystemLifecycleDashboard: The Lifecycle Dashboard.
         * @summary Get Ai System Life Cycle Dashboard
         * @param {string} projectId 
         * @param {AiLifecycleDashboardContent} [dashboardContent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet: async (projectId: string, dashboardContent?: AiLifecycleDashboardContent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet', 'projectId', projectId)
            const localVarPath = `/v1/projects/{project_id}/ai_system_life_cycle_dashboard`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dashboardContent !== undefined) {
                localVarQueryParameter['dashboard_content'] = dashboardContent;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Args:     object_id (UUID): The object ID.     object_type (enums.Concept): The object type. (enums.Concept)     response (Response): The response object.     project (schemas.Project): The project.     db (Session, optional): The database session.  Returns:     schemas.Comment: The updated control.
         * @summary Get Comments
         * @param {string} objectId 
         * @param {Concept} objectType 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet: async (objectId: string, objectType: Concept, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet', 'objectId', objectId)
            // verify required parameter 'objectType' is not null or undefined
            assertParamExists('getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet', 'objectType', objectType)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/comments/{object_type}/{object_id}`
                .replace('{object_id}', encodeURIComponent(String(objectId)))
                .replace('{object_type}', encodeURIComponent(String(objectType)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Control By Code
         * @param {string} controlCode 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlByCodeProjectsProjectIdControlsControlCodeGet: async (controlCode: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlCode' is not null or undefined
            assertParamExists('getControlByCodeProjectsProjectIdControlsControlCodeGet', 'controlCode', controlCode)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getControlByCodeProjectsProjectIdControlsControlCodeGet', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/controls/{control_code}`
                .replace('{control_code}', encodeURIComponent(String(controlCode)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Controls By Testing Test
         * @param {string} projectId 
         * @param {string} testingTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGet: async (projectId: string, testingTestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGet', 'projectId', projectId)
            // verify required parameter 'testingTestId' is not null or undefined
            assertParamExists('getControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGet', 'testingTestId', testingTestId)
            const localVarPath = `/v1/projects/{project_id}/testing/tests/{testing_test_id}/controls`
                .replace('{project_id}', encodeURIComponent(String(projectId)))
                .replace('{testing_test_id}', encodeURIComponent(String(testingTestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the logs for the given project and object id.  Args:     project_id (UUID): The project ID.     object_id (UUID): The object ID.  Returns:     List[Logs]: The logs.
         * @summary Get Logs
         * @param {string} objectId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsProjectsProjectIdLogsObjectIdGet: async (objectId: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('getLogsProjectsProjectIdLogsObjectIdGet', 'objectId', objectId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getLogsProjectsProjectIdLogsObjectIdGet', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/logs/{object_id}`
                .replace('{object_id}', encodeURIComponent(String(objectId)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all the controls of the project with the given id.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     Page[schemas.ControlWithoutComponents]: List of controls.
         * @summary Get Project Controls
         * @param {string} projectId 
         * @param {Array<string>} [tags] 
         * @param {string | null} [name] Filter by control name
         * @param {string | null} [framework] Filter by framework code
         * @param {string | null} [requirement] Filter by requirement id
         * @param {string | null} [status] Filter by control status
         * @param {boolean} [isAssignedToMe] Filter by controls assigned to me
         * @param {boolean} [isAssignedToMeForReview] Filter by controls assigned to me for review
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectControlsProjectsProjectIdControlsGet: async (projectId: string, tags?: Array<string>, name?: string | null, framework?: string | null, requirement?: string | null, status?: string | null, isAssignedToMe?: boolean, isAssignedToMeForReview?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectControlsProjectsProjectIdControlsGet', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/controls`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (framework !== undefined) {
                localVarQueryParameter['framework'] = framework;
            }

            if (requirement !== undefined) {
                localVarQueryParameter['requirement'] = requirement;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (isAssignedToMe !== undefined) {
                localVarQueryParameter['is_assigned_to_me'] = isAssignedToMe;
            }

            if (isAssignedToMeForReview !== undefined) {
                localVarQueryParameter['is_assigned_to_me_for_review'] = isAssignedToMeForReview;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Project Controls
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {Status | null} [status] Filter by control status
         * @param {string | null} [name] 
         * @param {Array<string> | null} [controlIds] Filter by control ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectControlsV1ProjectsProjectIdControlsGet: async (projectId: string, page?: number, size?: number, status?: Status | null, name?: string | null, controlIds?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectControlsV1ProjectsProjectIdControlsGet', 'projectId', projectId)
            const localVarPath = `/v1/projects/{project_id}/controls`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (controlIds) {
                localVarQueryParameter['control_ids'] = controlIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     Project: The project dashboard.
         * @summary Get Project Dashboard
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectDashboardProjectsProjectIdDashboardGet: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectDashboardProjectsProjectIdDashboardGet', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/dashboard`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the framework version of the project with the given id.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.FrameworkAggregator: framework version.
         * @summary Get Project Framework Version
         * @param {string} frameworkCode 
         * @param {string} version 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet: async (frameworkCode: string, version: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frameworkCode' is not null or undefined
            assertParamExists('getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet', 'frameworkCode', frameworkCode)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet', 'version', version)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/frameworks/{framework_code}/versions/{version}`
                .replace('{framework_code}', encodeURIComponent(String(frameworkCode)))
                .replace('{version}', encodeURIComponent(String(version)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the project with the given id. Args:     project_id (UUID): The project ID.  Returns:     Project: The project.
         * @summary Get Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectProjectsProjectIdGet: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectProjectsProjectIdGet', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Testing Test And Latest Result
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [sortBy] Column name to sort by
         * @param {boolean} [descending] Sort in descending order
         * @param {string | null} [name] Filter by name
         * @param {TestingTestStatus | null} [resultStatus] Filter by result status
         * @param {boolean | null} [status] Filter by test status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGet: async (projectId: string, page?: number, size?: number, sortBy?: string | null, descending?: boolean, name?: string | null, resultStatus?: TestingTestStatus | null, status?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGet', 'projectId', projectId)
            const localVarPath = `/v1/projects/{project_id}/testing/tests-results`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (resultStatus !== undefined) {
                localVarQueryParameter['result_status'] = resultStatus;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Testing Test Results
         * @param {string} projectId 
         * @param {string} testingTestId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {TestingTestStatus | null} [resultStatus] Filter by result status
         * @param {string | null} [sortBy] Column name to sort by
         * @param {boolean} [descending] Sort in descending order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGet: async (projectId: string, testingTestId: string, page?: number, size?: number, resultStatus?: TestingTestStatus | null, sortBy?: string | null, descending?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGet', 'projectId', projectId)
            // verify required parameter 'testingTestId' is not null or undefined
            assertParamExists('getTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGet', 'testingTestId', testingTestId)
            const localVarPath = `/v1/projects/{project_id}/testing/tests/{testing_test_id}/results`
                .replace('{project_id}', encodeURIComponent(String(projectId)))
                .replace('{testing_test_id}', encodeURIComponent(String(testingTestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (resultStatus !== undefined) {
                localVarQueryParameter['result_status'] = resultStatus;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the project frameworks.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.Project: The project.
         * @summary Project Frameworks Update
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost', 'projectId', projectId)
            const localVarPath = `/v1/projects/{project_id}/frameworks-update`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Control From Testing Test
         * @param {string} projectId 
         * @param {string} controlId 
         * @param {string} testingTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete: async (projectId: string, controlId: string, testingTestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete', 'projectId', projectId)
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete', 'controlId', controlId)
            // verify required parameter 'testingTestId' is not null or undefined
            assertParamExists('removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete', 'testingTestId', testingTestId)
            const localVarPath = `/v1/projects/{project_id}/testing/tests/{testing_test_id}/controls/{control_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)))
                .replace('{control_id}', encodeURIComponent(String(controlId)))
                .replace('{testing_test_id}', encodeURIComponent(String(testingTestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Testing Testing To Control
         * @param {string} projectId 
         * @param {string} controlId 
         * @param {string} testingTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut(projectId: string, controlId: string, testingTestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingTest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut(projectId, controlId, testingTestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a monitoring datasource.  Args:     testing_log (TestingLogCreate): Monitoring datasource data.     project (Project): Project.     db (Session): Database session.  Returns:     TestingLog: Monitoring datasource.  Raises:     HTTPException: AI System or testing metric not found.
         * @summary Create Testing Log
         * @param {string} projectId 
         * @param {TestingLogCreate} testingLogCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestingLogV1ProjectsProjectIdTestingLogsPost(projectId: string, testingLogCreate: TestingLogCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestingLogV1ProjectsProjectIdTestingLogsPost(projectId, testingLogCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.createTestingLogV1ProjectsProjectIdTestingLogsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Project
         * @param {string} projectId 
         * @param {string} [timeZone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportProjectV1ProjectsProjectIdExportPost(projectId: string, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportProjectV1ProjectsProjectIdExportPost(projectId, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.exportProjectV1ProjectsProjectIdExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the project freezed flag with the given id.  Args:     project_id (UUID): The project\'s id.     project_freezed (UpdateProjectFreezed): The freezed value for the project.     db (Session): Database session.  Returns:     schemas.Project: The updated project.
         * @summary Freeze Project Frameworks Update
         * @param {string} projectId 
         * @param {ProjectFrameworksFreezeUpdate} projectFrameworksFreezeUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(projectId: string, projectFrameworksFreezeUpdate: ProjectFrameworksFreezeUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(projectId, projectFrameworksFreezeUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     ProjectAiSystemLifecycleDashboard: The Lifecycle Dashboard.
         * @summary Get Ai System Life Cycle Dashboard
         * @param {string} projectId 
         * @param {AiLifecycleDashboardContent} [dashboardContent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(projectId: string, dashboardContent?: AiLifecycleDashboardContent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectAiSystemLifecycleDashboard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(projectId, dashboardContent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Args:     object_id (UUID): The object ID.     object_type (enums.Concept): The object type. (enums.Concept)     response (Response): The response object.     project (schemas.Project): The project.     db (Session, optional): The database session.  Returns:     schemas.Comment: The updated control.
         * @summary Get Comments
         * @param {string} objectId 
         * @param {Concept} objectType 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet(objectId: string, objectType: Concept, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Comment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet(objectId, objectType, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Control By Code
         * @param {string} controlCode 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlByCodeProjectsProjectIdControlsControlCodeGet(controlCode: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Control>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlByCodeProjectsProjectIdControlsControlCodeGet(controlCode, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getControlByCodeProjectsProjectIdControlsControlCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Controls By Testing Test
         * @param {string} projectId 
         * @param {string} testingTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGet(projectId: string, testingTestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Control>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGet(projectId, testingTestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the logs for the given project and object id.  Args:     project_id (UUID): The project ID.     object_id (UUID): The object ID.  Returns:     List[Logs]: The logs.
         * @summary Get Logs
         * @param {string} objectId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogsProjectsProjectIdLogsObjectIdGet(objectId: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Logs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogsProjectsProjectIdLogsObjectIdGet(objectId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getLogsProjectsProjectIdLogsObjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all the controls of the project with the given id.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     Page[schemas.ControlWithoutComponents]: List of controls.
         * @summary Get Project Controls
         * @param {string} projectId 
         * @param {Array<string>} [tags] 
         * @param {string | null} [name] Filter by control name
         * @param {string | null} [framework] Filter by framework code
         * @param {string | null} [requirement] Filter by requirement id
         * @param {string | null} [status] Filter by control status
         * @param {boolean} [isAssignedToMe] Filter by controls assigned to me
         * @param {boolean} [isAssignedToMeForReview] Filter by controls assigned to me for review
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectControlsProjectsProjectIdControlsGet(projectId: string, tags?: Array<string>, name?: string | null, framework?: string | null, requirement?: string | null, status?: string | null, isAssignedToMe?: boolean, isAssignedToMeForReview?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageControlList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectControlsProjectsProjectIdControlsGet(projectId, tags, name, framework, requirement, status, isAssignedToMe, isAssignedToMeForReview, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectControlsProjectsProjectIdControlsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Project Controls
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {Status | null} [status] Filter by control status
         * @param {string | null} [name] 
         * @param {Array<string> | null} [controlIds] Filter by control ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectControlsV1ProjectsProjectIdControlsGet(projectId: string, page?: number, size?: number, status?: Status | null, name?: string | null, controlIds?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageControl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectControlsV1ProjectsProjectIdControlsGet(projectId, page, size, status, name, controlIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectControlsV1ProjectsProjectIdControlsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     Project: The project dashboard.
         * @summary Get Project Dashboard
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectDashboardProjectsProjectIdDashboardGet(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDashboard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectDashboardProjectsProjectIdDashboardGet(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectDashboardProjectsProjectIdDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the framework version of the project with the given id.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.FrameworkAggregator: framework version.
         * @summary Get Project Framework Version
         * @param {string} frameworkCode 
         * @param {string} version 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet(frameworkCode: string, version: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformFrameworkVersionOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet(frameworkCode, version, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the project with the given id. Args:     project_id (UUID): The project ID.  Returns:     Project: The project.
         * @summary Get Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectProjectsProjectIdGet(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectAggregator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectProjectsProjectIdGet(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectProjectsProjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Testing Test And Latest Result
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [sortBy] Column name to sort by
         * @param {boolean} [descending] Sort in descending order
         * @param {string | null} [name] Filter by name
         * @param {TestingTestStatus | null} [resultStatus] Filter by result status
         * @param {boolean | null} [status] Filter by test status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGet(projectId: string, page?: number, size?: number, sortBy?: string | null, descending?: boolean, name?: string | null, resultStatus?: TestingTestStatus | null, status?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingTestAndResultPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGet(projectId, page, size, sortBy, descending, name, resultStatus, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Testing Test Results
         * @param {string} projectId 
         * @param {string} testingTestId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {TestingTestStatus | null} [resultStatus] Filter by result status
         * @param {string | null} [sortBy] Column name to sort by
         * @param {boolean} [descending] Sort in descending order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGet(projectId: string, testingTestId: string, page?: number, size?: number, resultStatus?: TestingTestStatus | null, sortBy?: string | null, descending?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingTestResultPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGet(projectId, testingTestId, page, size, resultStatus, sortBy, descending, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the project frameworks.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.Project: The project.
         * @summary Project Frameworks Update
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove Control From Testing Test
         * @param {string} projectId 
         * @param {string} controlId 
         * @param {string} testingTestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete(projectId: string, controlId: string, testingTestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete(projectId, controlId, testingTestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectsApi - factory interface
 */
export const ProjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Testing Testing To Control
         * @param {ProjectsApiAddTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut(requestParameters: ProjectsApiAddTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingTest> {
            return localVarFp.addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut(requestParameters.projectId, requestParameters.controlId, requestParameters.testingTestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a monitoring datasource.  Args:     testing_log (TestingLogCreate): Monitoring datasource data.     project (Project): Project.     db (Session): Database session.  Returns:     TestingLog: Monitoring datasource.  Raises:     HTTPException: AI System or testing metric not found.
         * @summary Create Testing Log
         * @param {ProjectsApiCreateTestingLogV1ProjectsProjectIdTestingLogsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestingLogV1ProjectsProjectIdTestingLogsPost(requestParameters: ProjectsApiCreateTestingLogV1ProjectsProjectIdTestingLogsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingLog> {
            return localVarFp.createTestingLogV1ProjectsProjectIdTestingLogsPost(requestParameters.projectId, requestParameters.testingLogCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Project
         * @param {ProjectsApiExportProjectV1ProjectsProjectIdExportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProjectV1ProjectsProjectIdExportPost(requestParameters: ProjectsApiExportProjectV1ProjectsProjectIdExportPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportProjectV1ProjectsProjectIdExportPost(requestParameters.projectId, requestParameters.timeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the project freezed flag with the given id.  Args:     project_id (UUID): The project\'s id.     project_freezed (UpdateProjectFreezed): The freezed value for the project.     db (Session): Database session.  Returns:     schemas.Project: The updated project.
         * @summary Freeze Project Frameworks Update
         * @param {ProjectsApiFreezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(requestParameters: ProjectsApiFreezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(requestParameters.projectId, requestParameters.projectFrameworksFreezeUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     ProjectAiSystemLifecycleDashboard: The Lifecycle Dashboard.
         * @summary Get Ai System Life Cycle Dashboard
         * @param {ProjectsApiGetAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(requestParameters: ProjectsApiGetAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectAiSystemLifecycleDashboard> {
            return localVarFp.getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(requestParameters.projectId, requestParameters.dashboardContent, options).then((request) => request(axios, basePath));
        },
        /**
         * Args:     object_id (UUID): The object ID.     object_type (enums.Concept): The object type. (enums.Concept)     response (Response): The response object.     project (schemas.Project): The project.     db (Session, optional): The database session.  Returns:     schemas.Comment: The updated control.
         * @summary Get Comments
         * @param {ProjectsApiGetCommentsProjectsProjectIdCommentsObjectTypeObjectIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet(requestParameters: ProjectsApiGetCommentsProjectsProjectIdCommentsObjectTypeObjectIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Comment>> {
            return localVarFp.getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet(requestParameters.objectId, requestParameters.objectType, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Control By Code
         * @param {ProjectsApiGetControlByCodeProjectsProjectIdControlsControlCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlByCodeProjectsProjectIdControlsControlCodeGet(requestParameters: ProjectsApiGetControlByCodeProjectsProjectIdControlsControlCodeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Control> {
            return localVarFp.getControlByCodeProjectsProjectIdControlsControlCodeGet(requestParameters.controlCode, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Controls By Testing Test
         * @param {ProjectsApiGetControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGet(requestParameters: ProjectsApiGetControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Control>> {
            return localVarFp.getControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGet(requestParameters.projectId, requestParameters.testingTestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the logs for the given project and object id.  Args:     project_id (UUID): The project ID.     object_id (UUID): The object ID.  Returns:     List[Logs]: The logs.
         * @summary Get Logs
         * @param {ProjectsApiGetLogsProjectsProjectIdLogsObjectIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsProjectsProjectIdLogsObjectIdGet(requestParameters: ProjectsApiGetLogsProjectsProjectIdLogsObjectIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Logs>> {
            return localVarFp.getLogsProjectsProjectIdLogsObjectIdGet(requestParameters.objectId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all the controls of the project with the given id.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     Page[schemas.ControlWithoutComponents]: List of controls.
         * @summary Get Project Controls
         * @param {ProjectsApiGetProjectControlsProjectsProjectIdControlsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectControlsProjectsProjectIdControlsGet(requestParameters: ProjectsApiGetProjectControlsProjectsProjectIdControlsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageControlList> {
            return localVarFp.getProjectControlsProjectsProjectIdControlsGet(requestParameters.projectId, requestParameters.tags, requestParameters.name, requestParameters.framework, requestParameters.requirement, requestParameters.status, requestParameters.isAssignedToMe, requestParameters.isAssignedToMeForReview, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Project Controls
         * @param {ProjectsApiGetProjectControlsV1ProjectsProjectIdControlsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectControlsV1ProjectsProjectIdControlsGet(requestParameters: ProjectsApiGetProjectControlsV1ProjectsProjectIdControlsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageControl> {
            return localVarFp.getProjectControlsV1ProjectsProjectIdControlsGet(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.status, requestParameters.name, requestParameters.controlIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     Project: The project dashboard.
         * @summary Get Project Dashboard
         * @param {ProjectsApiGetProjectDashboardProjectsProjectIdDashboardGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectDashboardProjectsProjectIdDashboardGet(requestParameters: ProjectsApiGetProjectDashboardProjectsProjectIdDashboardGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectDashboard> {
            return localVarFp.getProjectDashboardProjectsProjectIdDashboardGet(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the framework version of the project with the given id.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.FrameworkAggregator: framework version.
         * @summary Get Project Framework Version
         * @param {ProjectsApiGetProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters: ProjectsApiGetProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlatformFrameworkVersionOverview> {
            return localVarFp.getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters.frameworkCode, requestParameters.version, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the project with the given id. Args:     project_id (UUID): The project ID.  Returns:     Project: The project.
         * @summary Get Project
         * @param {ProjectsApiGetProjectProjectsProjectIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectProjectsProjectIdGet(requestParameters: ProjectsApiGetProjectProjectsProjectIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectAggregator> {
            return localVarFp.getProjectProjectsProjectIdGet(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Testing Test And Latest Result
         * @param {ProjectsApiGetTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGet(requestParameters: ProjectsApiGetTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingTestAndResultPage> {
            return localVarFp.getTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGet(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.resultStatus, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Testing Test Results
         * @param {ProjectsApiGetTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGet(requestParameters: ProjectsApiGetTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingTestResultPage> {
            return localVarFp.getTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGet(requestParameters.projectId, requestParameters.testingTestId, requestParameters.page, requestParameters.size, requestParameters.resultStatus, requestParameters.sortBy, requestParameters.descending, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the project frameworks.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.Project: The project.
         * @summary Project Frameworks Update
         * @param {ProjectsApiProjectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(requestParameters: ProjectsApiProjectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Control From Testing Test
         * @param {ProjectsApiRemoveControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete(requestParameters: ProjectsApiRemoveControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete(requestParameters.projectId, requestParameters.controlId, requestParameters.testingTestId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut operation in ProjectsApi.
 */
export interface ProjectsApiAddTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPutRequest {
    readonly projectId: string

    readonly controlId: string

    readonly testingTestId: string
}

/**
 * Request parameters for createTestingLogV1ProjectsProjectIdTestingLogsPost operation in ProjectsApi.
 */
export interface ProjectsApiCreateTestingLogV1ProjectsProjectIdTestingLogsPostRequest {
    readonly projectId: string

    readonly testingLogCreate: TestingLogCreate
}

/**
 * Request parameters for exportProjectV1ProjectsProjectIdExportPost operation in ProjectsApi.
 */
export interface ProjectsApiExportProjectV1ProjectsProjectIdExportPostRequest {
    readonly projectId: string

    readonly timeZone?: string
}

/**
 * Request parameters for freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch operation in ProjectsApi.
 */
export interface ProjectsApiFreezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatchRequest {
    readonly projectId: string

    readonly projectFrameworksFreezeUpdate: ProjectFrameworksFreezeUpdate
}

/**
 * Request parameters for getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet operation in ProjectsApi.
 */
export interface ProjectsApiGetAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGetRequest {
    readonly projectId: string

    readonly dashboardContent?: AiLifecycleDashboardContent
}

/**
 * Request parameters for getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet operation in ProjectsApi.
 */
export interface ProjectsApiGetCommentsProjectsProjectIdCommentsObjectTypeObjectIdGetRequest {
    readonly objectId: string

    readonly objectType: Concept

    readonly projectId: string
}

/**
 * Request parameters for getControlByCodeProjectsProjectIdControlsControlCodeGet operation in ProjectsApi.
 */
export interface ProjectsApiGetControlByCodeProjectsProjectIdControlsControlCodeGetRequest {
    readonly controlCode: string

    readonly projectId: string
}

/**
 * Request parameters for getControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGet operation in ProjectsApi.
 */
export interface ProjectsApiGetControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGetRequest {
    readonly projectId: string

    readonly testingTestId: string
}

/**
 * Request parameters for getLogsProjectsProjectIdLogsObjectIdGet operation in ProjectsApi.
 */
export interface ProjectsApiGetLogsProjectsProjectIdLogsObjectIdGetRequest {
    readonly objectId: string

    readonly projectId: string
}

/**
 * Request parameters for getProjectControlsProjectsProjectIdControlsGet operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectControlsProjectsProjectIdControlsGetRequest {
    readonly projectId: string

    readonly tags?: Array<string>

    /**
     * Filter by control name
     */
    readonly name?: string | null

    /**
     * Filter by framework code
     */
    readonly framework?: string | null

    /**
     * Filter by requirement id
     */
    readonly requirement?: string | null

    /**
     * Filter by control status
     */
    readonly status?: string | null

    /**
     * Filter by controls assigned to me
     */
    readonly isAssignedToMe?: boolean

    /**
     * Filter by controls assigned to me for review
     */
    readonly isAssignedToMeForReview?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for getProjectControlsV1ProjectsProjectIdControlsGet operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectControlsV1ProjectsProjectIdControlsGetRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    /**
     * Filter by control status
     */
    readonly status?: Status | null

    readonly name?: string | null

    /**
     * Filter by control ids
     */
    readonly controlIds?: Array<string> | null
}

/**
 * Request parameters for getProjectDashboardProjectsProjectIdDashboardGet operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectDashboardProjectsProjectIdDashboardGetRequest {
    readonly projectId: string
}

/**
 * Request parameters for getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGetRequest {
    readonly frameworkCode: string

    readonly version: string

    readonly projectId: string
}

/**
 * Request parameters for getProjectProjectsProjectIdGet operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectProjectsProjectIdGetRequest {
    readonly projectId: string
}

/**
 * Request parameters for getTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGet operation in ProjectsApi.
 */
export interface ProjectsApiGetTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGetRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    /**
     * Column name to sort by
     */
    readonly sortBy?: string | null

    /**
     * Sort in descending order
     */
    readonly descending?: boolean

    /**
     * Filter by name
     */
    readonly name?: string | null

    /**
     * Filter by result status
     */
    readonly resultStatus?: TestingTestStatus | null

    /**
     * Filter by test status
     */
    readonly status?: boolean | null
}

/**
 * Request parameters for getTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGet operation in ProjectsApi.
 */
export interface ProjectsApiGetTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGetRequest {
    readonly projectId: string

    readonly testingTestId: string

    readonly page?: number

    readonly size?: number

    /**
     * Filter by result status
     */
    readonly resultStatus?: TestingTestStatus | null

    /**
     * Column name to sort by
     */
    readonly sortBy?: string | null

    /**
     * Sort in descending order
     */
    readonly descending?: boolean
}

/**
 * Request parameters for projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost operation in ProjectsApi.
 */
export interface ProjectsApiProjectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePostRequest {
    readonly projectId: string
}

/**
 * Request parameters for removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete operation in ProjectsApi.
 */
export interface ProjectsApiRemoveControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDeleteRequest {
    readonly projectId: string

    readonly controlId: string

    readonly testingTestId: string
}

/**
 * ProjectsApi - object-oriented interface
 */
export class ProjectsApi extends BaseAPI {
    /**
     * 
     * @summary Add Testing Testing To Control
     * @param {ProjectsApiAddTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut(requestParameters: ProjectsApiAddTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPutRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).addTestingTestingToControlV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdPut(requestParameters.projectId, requestParameters.controlId, requestParameters.testingTestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a monitoring datasource.  Args:     testing_log (TestingLogCreate): Monitoring datasource data.     project (Project): Project.     db (Session): Database session.  Returns:     TestingLog: Monitoring datasource.  Raises:     HTTPException: AI System or testing metric not found.
     * @summary Create Testing Log
     * @param {ProjectsApiCreateTestingLogV1ProjectsProjectIdTestingLogsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTestingLogV1ProjectsProjectIdTestingLogsPost(requestParameters: ProjectsApiCreateTestingLogV1ProjectsProjectIdTestingLogsPostRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).createTestingLogV1ProjectsProjectIdTestingLogsPost(requestParameters.projectId, requestParameters.testingLogCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Project
     * @param {ProjectsApiExportProjectV1ProjectsProjectIdExportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportProjectV1ProjectsProjectIdExportPost(requestParameters: ProjectsApiExportProjectV1ProjectsProjectIdExportPostRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).exportProjectV1ProjectsProjectIdExportPost(requestParameters.projectId, requestParameters.timeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the project freezed flag with the given id.  Args:     project_id (UUID): The project\'s id.     project_freezed (UpdateProjectFreezed): The freezed value for the project.     db (Session): Database session.  Returns:     schemas.Project: The updated project.
     * @summary Freeze Project Frameworks Update
     * @param {ProjectsApiFreezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(requestParameters: ProjectsApiFreezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatchRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).freezeProjectFrameworksUpdateV1ProjectsProjectIdFreezeFrameworksUpdatePatch(requestParameters.projectId, requestParameters.projectFrameworksFreezeUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     ProjectAiSystemLifecycleDashboard: The Lifecycle Dashboard.
     * @summary Get Ai System Life Cycle Dashboard
     * @param {ProjectsApiGetAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(requestParameters: ProjectsApiGetAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getAiSystemLifeCycleDashboardV1ProjectsProjectIdAiSystemLifeCycleDashboardGet(requestParameters.projectId, requestParameters.dashboardContent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Args:     object_id (UUID): The object ID.     object_type (enums.Concept): The object type. (enums.Concept)     response (Response): The response object.     project (schemas.Project): The project.     db (Session, optional): The database session.  Returns:     schemas.Comment: The updated control.
     * @summary Get Comments
     * @param {ProjectsApiGetCommentsProjectsProjectIdCommentsObjectTypeObjectIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet(requestParameters: ProjectsApiGetCommentsProjectsProjectIdCommentsObjectTypeObjectIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getCommentsProjectsProjectIdCommentsObjectTypeObjectIdGet(requestParameters.objectId, requestParameters.objectType, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Control By Code
     * @param {ProjectsApiGetControlByCodeProjectsProjectIdControlsControlCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlByCodeProjectsProjectIdControlsControlCodeGet(requestParameters: ProjectsApiGetControlByCodeProjectsProjectIdControlsControlCodeGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getControlByCodeProjectsProjectIdControlsControlCodeGet(requestParameters.controlCode, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Controls By Testing Test
     * @param {ProjectsApiGetControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGet(requestParameters: ProjectsApiGetControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getControlsByTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsGet(requestParameters.projectId, requestParameters.testingTestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the logs for the given project and object id.  Args:     project_id (UUID): The project ID.     object_id (UUID): The object ID.  Returns:     List[Logs]: The logs.
     * @summary Get Logs
     * @param {ProjectsApiGetLogsProjectsProjectIdLogsObjectIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLogsProjectsProjectIdLogsObjectIdGet(requestParameters: ProjectsApiGetLogsProjectsProjectIdLogsObjectIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getLogsProjectsProjectIdLogsObjectIdGet(requestParameters.objectId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all the controls of the project with the given id.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     Page[schemas.ControlWithoutComponents]: List of controls.
     * @summary Get Project Controls
     * @param {ProjectsApiGetProjectControlsProjectsProjectIdControlsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectControlsProjectsProjectIdControlsGet(requestParameters: ProjectsApiGetProjectControlsProjectsProjectIdControlsGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectControlsProjectsProjectIdControlsGet(requestParameters.projectId, requestParameters.tags, requestParameters.name, requestParameters.framework, requestParameters.requirement, requestParameters.status, requestParameters.isAssignedToMe, requestParameters.isAssignedToMeForReview, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Project Controls
     * @param {ProjectsApiGetProjectControlsV1ProjectsProjectIdControlsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectControlsV1ProjectsProjectIdControlsGet(requestParameters: ProjectsApiGetProjectControlsV1ProjectsProjectIdControlsGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectControlsV1ProjectsProjectIdControlsGet(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.status, requestParameters.name, requestParameters.controlIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the project dashboard for the given project id.  Args:     project_id (UUID): The project ID.  Returns:     Project: The project dashboard.
     * @summary Get Project Dashboard
     * @param {ProjectsApiGetProjectDashboardProjectsProjectIdDashboardGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectDashboardProjectsProjectIdDashboardGet(requestParameters: ProjectsApiGetProjectDashboardProjectsProjectIdDashboardGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectDashboardProjectsProjectIdDashboardGet(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the framework version of the project with the given id.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.FrameworkAggregator: framework version.
     * @summary Get Project Framework Version
     * @param {ProjectsApiGetProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters: ProjectsApiGetProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectFrameworkVersionProjectsProjectIdFrameworksFrameworkCodeVersionsVersionGet(requestParameters.frameworkCode, requestParameters.version, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the project with the given id. Args:     project_id (UUID): The project ID.  Returns:     Project: The project.
     * @summary Get Project
     * @param {ProjectsApiGetProjectProjectsProjectIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectProjectsProjectIdGet(requestParameters: ProjectsApiGetProjectProjectsProjectIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectProjectsProjectIdGet(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Testing Test And Latest Result
     * @param {ProjectsApiGetTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGet(requestParameters: ProjectsApiGetTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getTestingTestAndLatestResultV1ProjectsProjectIdTestingTestsResultsGet(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.resultStatus, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Testing Test Results
     * @param {ProjectsApiGetTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGet(requestParameters: ProjectsApiGetTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGetRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getTestingTestResultsV1ProjectsProjectIdTestingTestsTestingTestIdResultsGet(requestParameters.projectId, requestParameters.testingTestId, requestParameters.page, requestParameters.size, requestParameters.resultStatus, requestParameters.sortBy, requestParameters.descending, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the project frameworks.  Args:     project_id (UUID): The project\'s id.     db (Session): Database session.  Returns:     schemas.Project: The project.
     * @summary Project Frameworks Update
     * @param {ProjectsApiProjectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(requestParameters: ProjectsApiProjectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePostRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).projectFrameworksUpdateV1ProjectsProjectIdFrameworksUpdatePost(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Control From Testing Test
     * @param {ProjectsApiRemoveControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete(requestParameters: ProjectsApiRemoveControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).removeControlFromTestingTestV1ProjectsProjectIdTestingTestsTestingTestIdControlsControlIdDelete(requestParameters.projectId, requestParameters.controlId, requestParameters.testingTestId, options).then((request) => request(this.axios, this.basePath));
    }
}

